module.exports = __webpack_public_path__ + "static/media/pattern8.eb74bacc.svg";